module.exports = __webpack_public_path__ + "static/media/9x12no3-min.eb69c3f9.jpg";